<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/x13dhh/tc-custom/9781418566258.jpg?1718043995916" alt="This image is the cover for the book Renegade, The Lost Book"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Renegade, The Lost Book
      </h1>
      <p class="bookDescription body article font2">
        <p><b>In <i>Renegade, </i>the third in the Lost Books series, a YA spin-off of the <i>New York Times </i>bestselling Circle series, one of the chosen will leave his world . . . and enter ours.</b></p><p><b>One of the chosen has gone renegade.</b></p><p>Turning his back on all that he once believed, Billos does the forbidden and enters into a Book of History. He lands in a reality as foreign to him as water is to oil—a place called Paradise, Colorado. He has strange new powers given to him courtesy of a mysterious figure known as Marsuvees Black.</p><p>The chosen four have survived the desert, escaped the Black Forest, battled the Horde, and added a spirited refugee to their number. But nothing has prepared them for the showdown that Billos, the renegade, is luring them into. </p>Book 3 of 6 in the Lost Books series (a spin-off of the Circle Series)Lost Books 1: ChosenLost Books 2: InfidelLost Books 3: RenegadeLost Books 4: ChaosLost Books 5: LunaticLost Books 6: ElyonCircle Book 0: GreenCircle Book 1: BlackCircle Book 2: RedCircle Book 3: WhiteFull-length book (70,000 words)
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Ted Dekker
      </h2>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Thomas Nelson
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?187c1e7d